<template>
  <div class="business-page bg--color-01">
    <top-section />
    <analytics-exchanges />
    <token-ecosystem />
    <business-synergy />
    <business-income-sources />
    <business-edge />
    <business-potential />
    <subscribe-block bg-class="bg--color-02" />
  </div>
</template>

<script>
import { getDefaultHeadData } from '@/lib/utils'

export default {
  name: 'BusinessPage',
  components: {
    TopSection: () => import('@/components/business/TopSection.vue'),
    AnalyticsExchanges: () =>
      import('@/components/business/AnalyticsExchanges.vue'),
    TokenEcosystem: () => import('@/components/business/TokenEcosystem.vue'),
    BusinessSynergy: () => import('@/components/business/BusinessSynergy.vue'),
    BusinessIncomeSources: () =>
      import('@/components/business/BusinessIncomeSources.vue'),
    BusinessEdge: () => import('@/components/business/BusinessEdge.vue'),
    BusinessPotential: () =>
      import('@/components/business/BusinessPotential.vue'),
    SubscribeBlock: () => import('@/components/welcome/SubscribeBlock.vue'),
  },
  head () {
    return getDefaultHeadData({
      title: this.$t('meta.business.title'),
      description: this.$t('meta.business.description'),
      locale: this.$i18n.locale,
    })
  },
}
</script>

<style lang="scss" scoped>
.business-page {
  flex: 1;
}
</style>
